import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	projectSettingsTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectSettingsTitleGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	projectSettingsTitle: {
		id: 'platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title',
		defaultMessage: 'Project settings',
		description: 'Title of the breadcrumb that navigates to project settings page',
	},
	projectSettingsTitleGalaxia: {
		id: 'platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title-galaxia',
		defaultMessage: 'Space settings',
		description: 'Title of the breadcrumb that navigates to project settings page',
	},
});
export default messages;
